import React, { useState } from 'react';
import { CrudStyles } from '../shared/Crud';
import DeliveryDriverSelectorModal from '../Deliveries/steps/DeliveryDriverSelectorModal';
import { FieldHint, FilterField } from './styles';

const { Button } = CrudStyles;

const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 10px',
    background: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '4px',
    fontSize: '13px',
    color: '#1e40af',
    maxWidth: '100%',
};

const clearButtonStyle = {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '0 2px',
    fontSize: '14px',
    lineHeight: 1,
    color: '#1e40af',
};

/**
 * Campo de filtro de motorista: reutiliza a lista paginada de DeliveryDriverSelectorModal.
 */
export default function ReportDriverFilter({
    label = 'Motorista',
    driverId,
    driverName = '',
    onSelect,
    disabled = false,
    error,
    hint,
    modalZIndex = 10050,
}) {
    const [modalOpen, setModalOpen] = useState(false);
    const hasSelection = driverId != null && String(driverId).trim() !== '';
    const hasError = Boolean(error);

    return (
        <>
            <FilterField $hasError={hasError}>
                <span>{label}</span>
                {hasSelection ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        <div style={badgeStyle} title={driverName || undefined}>
                            <span
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {driverName || `Motorista #${driverId}`}
                            </span>
                            <button
                                type="button"
                                onClick={() => onSelect?.(null)}
                                disabled={disabled}
                                style={clearButtonStyle}
                                aria-label="Remover filtro de motorista"
                                title="Remover filtro de motorista"
                            >
                                ✕
                            </button>
                        </div>
                        <Button
                            type="button"
                            variant="outline"
                            disabled={disabled}
                            onClick={() => setModalOpen(true)}
                            style={{ alignSelf: 'flex-start' }}
                        >
                            Alterar motorista
                        </Button>
                    </div>
                ) : (
                    <Button
                        type="button"
                        variant="outline"
                        disabled={disabled}
                        onClick={() => setModalOpen(true)}
                        style={{ alignSelf: 'flex-start' }}
                    >
                        Selecionar motorista
                    </Button>
                )}
                {(hasError || hint) && (
                    <FieldHint $error={hasError}>{error || hint}</FieldHint>
                )}
            </FilterField>

            <DeliveryDriverSelectorModal
                open={modalOpen}
                currentDriverId={hasSelection ? driverId : null}
                zIndex={modalZIndex}
                onClose={() => setModalOpen(false)}
                onSelectDriver={(driver) => {
                    if (driver?.id == null) return;
                    onSelect?.({
                        id: driver.id,
                        name: driver.name ?? `Motorista #${driver.id}`,
                    });
                    setModalOpen(false);
                }}
                onClearDriver={() => {
                    onSelect?.(null);
                    setModalOpen(false);
                }}
                removalConfirmMessage="Deseja remover o filtro de motorista?"
                removeButtonTitle="Remover filtro de motorista"
            />
        </>
    );
}
